import script from "./Menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./Menu.vue?vue&type=script&setup=true&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=7c279d63&lang=sass"

const __exports__ = script;

export default __exports__